import { useContext } from 'react';
import { ShopSearchContext } from '~/contexts/shop-search-context';

export const useShopSearch = () => {
  const context = useContext(ShopSearchContext);
  if (!context) {
    return {
      searchedPostcode: null,
      searchedShopProviders: {},
      setSearchedPostcode: () => {},
      setSearchedShopProviders: () => {}
    };
  }
  return context;
};
